import { CONFIG_WIRES } from './config.wires';
import { CORE_WIRES } from './core.wires';
import { DISCOVERY_WALL_WIRES } from './discovery-wall.wires';
import { EMPATHIZE_WIRES } from './empathize.wires';
import { HISTORY_WIRES } from './history.wires';
import { LOCALE_WIRES } from './locale.wires';
import { NO_RESULTS_WIRES } from './no-results.wires';
import { QUERY_ORIGIN_WIRES } from './query-origin.wires';
import { QUERY_SIGNALS_WIRES } from './query-signals.wires';
import { RECOMMENDATIONS_WIRES } from './recommendations.wires';
import { SEARCH_WIRES } from './search.wires';
import { SORT_WIRES } from './sort.wires';
import { TRACKING_WIRES } from './tracking.wires';
import { URL_WIRES } from './url.wires';

export * from './wires.factory';
export const WIRES = {
  ...CORE_WIRES,
  ...CONFIG_WIRES,
  ...DISCOVERY_WALL_WIRES,
  ...EMPATHIZE_WIRES,
  ...HISTORY_WIRES,
  ...LOCALE_WIRES,
  ...NO_RESULTS_WIRES,
  ...QUERY_ORIGIN_WIRES,
  ...QUERY_SIGNALS_WIRES,
  ...RECOMMENDATIONS_WIRES,
  ...SEARCH_WIRES,
  ...SORT_WIRES,
  ...TRACKING_WIRES,
  ...URL_WIRES
};
